import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/student/email-verification`;

export const studentEmailVerificationRoutesObj = {
  view: `${baseRoute}/:requestId/:tokenId`,
} as const;

export type IStudentEmailVerificationRouteParams = IExtractRouteParamMap<
  typeof studentEmailVerificationRoutesObj
>;

export const studentEmailVerificationPath = createPaths<
  typeof studentEmailVerificationRoutesObj,
  IStudentEmailVerificationRouteParams
>(studentEmailVerificationRoutesObj);
